import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Hero image served from public folder for LCP preload discovery
const heroImage = "/images/hero-banner.webp";

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut" as const,
    },
  },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const imageReveal = {
  hidden: { scale: 1.1, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 1.2,
      ease: "easeOut" as const,
    },
  },
};

export const HeroSection = () => {
  return (
    <section className="relative min-h-[85vh] md:min-h-[90vh] flex items-center overflow-hidden">
      {/* Background Image with Reveal Animation - Priority loaded for LCP */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={imageReveal}
        className="absolute inset-0 z-0"
      >
        <img
          src={heroImage}
          alt="CALIMSTYLE Ring - Premium wellness accessory"
          className="w-full h-full object-cover"
          width={1536}
          height={973}
          fetchPriority="high"
          loading="eager"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/70 to-transparent md:from-background/90 md:via-background/60" />
      </motion.div>

      {/* Content */}
      <div className="container-calim relative z-10">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
          className="max-w-2xl"
        >
          <motion.p
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
            className="text-subhead mb-3 md:mb-4"
          >
            Magnetic Copper Wellness
          </motion.p>
          
          <motion.h1
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
            className="text-display mb-4 md:mb-6 text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl"
          >
            Find Your Calm
            <br />
            <span className="italic">Anytime, Anywhere</span>
          </motion.h1>
          
          <motion.p
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
            className="text-body-lg mb-6 md:mb-8 max-w-lg text-base md:text-lg lg:text-xl"
          >
            Discover our magnetic copper rings and bracelets, worn by 2,500+ wellness seekers daily.
          </motion.p>
          
          <motion.div
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
            className="flex flex-col sm:flex-row gap-3 md:gap-4"
          >
            <Link to="/collections" className="btn-calim-primary text-center">
              Shop Collections
            </Link>
            <Link to="/about" className="btn-calim-secondary text-center">
              Our Story
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
